import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { type CaseTasksDocument, caseTaskCollectionResourceSelector } from "@/types/caseTask.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";

export const useFetchMrtDashboardTasks = (
    globalFilter: string,
): UseQueryResult<CaseTasksDocument> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        queryKey: ["dashboard-tasks-table-data", globalFilter],
        queryFn: async () => {
            const response = await fetch(
                apiUrl(`/case-task/dashboard/${globalFilter === "" ? "" : globalFilter}`),
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                },
            );

            return await response.json();
        },
        select: caseTaskCollectionResourceSelector,
        staleTime: 1000 * 30, //30 seconds
    });
};
